module.exports = __webpack_public_path__ + "static/media/logo.77c7e9d6.png";